import { HomePage } from 'modules/home';
import React from 'react';

const Home = () => <HomePage />;

// when home page succesfully loaded, ensure order stepper is prepared for next step.
// adding delay so it won't block the initial rendering
export default Home;
